export default __webpack_public_path__ + "static/media/crime.590a87ff.svg";